import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { APP_GRAPHQL_ENDPOINT } from '../../config';

/**
 * Anonymous Apollo client for the public forms app. No auth header —
 * gating happens server-side via FormDocument.isPublic.
 *
 * We do declare the session via `x-access-type: PUBLIC_FORM` so
 * resolvers that need a wider gate than `auth.userId` (e.g.
 * googlePlacesAutocomplete for the AddressInput element) can opt
 * public-form callers in explicitly. Mirrors the existing onboarding
 * session pattern in apps/graphql/src/util/auth.ts.
 */
export const apolloClient = new ApolloClient({
  link: new HttpLink({
    uri: APP_GRAPHQL_ENDPOINT,
    headers: { 'x-access-type': 'PUBLIC_FORM' },
  }),
  cache: new InMemoryCache({
    typePolicies: {
      // Row ids are unique only within their response set; normalised,
      // two sets with a row "1" would read back each other's values.
      DocumentResponseSetRow: { keyFields: false },
    },
  }),
  defaultOptions: {
    watchQuery: { fetchPolicy: 'cache-and-network' },
    query: { fetchPolicy: 'network-only' },
  },
});
